import React, { Fragment, useContext } from 'react';
import { Menu, Header, Input, Dropdown } from 'semantic-ui-react';
import { Calendar } from 'react-widgets';
import { RootStoreContext } from '../../../../App/stores/RootStore';
import { observer } from 'mobx-react-lite';

const RequestNoteFilters = () => {
  const rootStore = useContext(RootStoreContext);
  const { predicate, setPredicate } = rootStore.requestNoteStore;
  const { getNoteOptions } = rootStore.commonStore;

  return (
    <Fragment>
      <Menu vertical size={'large'} style={{ width: '100%' }}>
        <Header icon={'filter'} attached color={'teal'} content={'Filters'} />
        <Menu.Item
          active={predicate.size === 0}
          onClick={() => setPredicate('My Notes', 'true')}
          color={'blue'} name={'My Notes'}
          content={'My Notes'}
        />
        <Menu.Item active={predicate.has('isGoing')}
          onClick={() => setPredicate('All Notes', 'true')}
          color={'blue'} name={'username'} content={"All Notes"} />
        <Menu.Item>
          <Input label="Email" placeholder='Search...'
            onChange={email => setPredicate('email', email.target.value.toString())}
            value={predicate.get('email' || "")} />
        </Menu.Item>
        <Menu.Item>
          <Dropdown
            placeholder='Select a note type...'
            fluid
            selection
            options={getNoteOptions([])}
            onChange={noteType => setPredicate('noteType', noteType.currentTarget.innerText)}
            value={predicate.get('noteType' || "")}
          />
        </Menu.Item>
      </Menu>
      <Header icon={'calendar'} attached color={'teal'} content={'Select Date'} />
      <Calendar
        onChange={date => setPredicate('dateCreated', date!)}
        value={predicate.get('dateCreated' || new Date())}
      />
    </Fragment>
  )
}

export default observer(RequestNoteFilters);